import { createSlice } from "@reduxjs/toolkit"

const initialState: boolean = false

export const progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    画面ロック開始: (state) => true,
    画面ロック解除: (state) => false,
  },
})

export const { 画面ロック開始, 画面ロック解除 } = progressSlice.actions
